import styled from 'styled-components'

export const Menu = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 4px;
	width: 100%;
	padding: 0 16px 16px;
`
